import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import Button from 'components/ui/button';
import SearchGestor from './SearchGestor';
import { User } from 'types/user';
import { useAuth } from 'context/AuthContext';
import { getStorageItem, setStorageItem } from 'utils/storage';
import { findLateralMenagers } from 'services/profile.service';
import { getTasksPendingApprovalParticipants } from 'services/dashboard.service';

interface IProps {
  isRoot: boolean;
  title?: string | undefined | null;
  onSubmitSearch: (id: any) => void;
}

// const pages = ['minha-equipe', 'validar-apreciar-realizacao', 'participantes-da-realizacao', 'dupla-lideranca'];
const pages = ['minha-equipe', 'validar-apreciar-realizacao', 'participantes-da-realizacao'];

export default function Header({ isRoot, title, onSubmitSearch }: IProps) {
  const location = useLocation();
  const { pathname } = location;

  const { user, userInfo } = useAuth();

  const [internalUser, setInternalUser] = useState<User>();
  const [lateralManagers, setLateralManagers] = useState<User[]>();
  const [showModalLateral, setShowModalLateral] = useState(false);
  const [tasksPendingApproval, setTasksPendingApproval] = useState<any[]>();
  const [currentPath, setCurrentPath] = useState<string | undefined>();

  const isVacationManager = useMemo(() => !!internalUser && !!user && internalUser._id !== user._id, [internalUser, user]);

  const canViewTabEquipe = useMemo(
    () =>
      !!userInfo?.ro.match(/(3GUE|2GUT|2GCA|2GUA)/gi) ||
      !!userInfo?.ro.match(/(2GUE|1GUT|1GUA|1GCA)/gi) ||
      userInfo?.cod_funcao === 3002 ||
      userInfo?.cod_funcao === 3003 ||
      userInfo?.cod_funcao === 4005 ||
      userInfo?.cod_funcao === 4007,
    [userInfo],
  );

  useEffect(() => {
    const paths = pathname.match(/\/([^/]+)\/?$/gi);

    if (Array.isArray(paths)) {
      const path = paths[0].replace(/\//gi, '');

      if (pages.includes(path)) {
        setCurrentPath(path);
      }
    }
  }, [pathname]);

  useEffect(() => {
    async function getVacationManagers() {
      try {
        if (!userInfo || !user) return;

        if (
          (userInfo.cod_etapa && userInfo.cod_etapa > 0 && userInfo.cod_etapa <= 5) ||
          (Array.isArray(userInfo?.mad_dupla) &&
            userInfo?.mad_dupla?.some((md: any) => typeof md.cod_etapa === 'number' && md.cod_etapa > 0 && md.cod_etapa <= 5))
        ) {
          const managers = await findLateralMenagers();
          const storedManager = getStorageItem('manager_lateralidade');

          setLateralManagers(managers);

          if (!!storedManager && storedManager.length) {
            const lateralManager = managers?.length ? managers.find((x: { _id: any }) => x._id === storedManager) : null;

            if (!!lateralManager?._id && !!lateralManager?.extra?.id) {
              setInternalUser(lateralManager);
            } else {
              setInternalUser(user);
            }
          } else {
            setInternalUser(user);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (user && userInfo) {
      getVacationManagers();
    }

    document.addEventListener('reload:lateralidade', getVacationManagers, false);

    return () => {
      document.removeEventListener('reload:lateralidade', getVacationManagers);
    };
  }, [userInfo, user]);

  useEffect(() => {
    if (!internalUser) return;

    async function getPendingApproval() {
      try {
        if (!internalUser || !canViewTabEquipe) return;

        const tasksPending = await getTasksPendingApprovalParticipants(internalUser._id);

        setTasksPendingApproval(tasksPending);
      } catch (e) {
        console.log(e);
      }
    }

    getPendingApproval();

    document.addEventListener('reload:pendingapproval', getPendingApproval, false);

    return () => {
      document.removeEventListener('reload:pendingapproval', getPendingApproval);
    };
  }, [internalUser, canViewTabEquipe]);

  return (
    <>
      {!!isRoot ? (
        <>
          <div className="mb-3 lg:mb-16 flex justify-between items-center">
            <div className="flex flex-ro items-center space-x-3">
              <Link to="/">
                <button className="rounded-full bg-purple flex justify-center items-center p-1">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>

              <h1 className="text-lg lg:text-3xl py-1 rounded-full">{!!title ? title : 'Minha Equipe'}</h1>
            </div>

            {currentPath === 'minha-equipe' && !user?.extra.rede && (
              <div>
                <Button
                  className="px-6 py-2 rounded-sm uppercase"
                  color="outlinePurple"
                  onClick={() => setShowModalLateral(true)}
                >
                  Visualizar equipe lateral
                </Button>
              </div>
            )}

            {/* {(currentPath === 'validar-apreciar-realizacao' || currentPath === 'participantes-da-realizacao') &&
              !isVacationManager &&
              Array.isArray(lateralManagers) &&
              !!lateralManagers.length && (
                <div>
                  <Button
                    className="px-6 py-2 rounded-sm uppercase"
                    color="outlinePurple"
                    onClick={() => setShowModalLateral(true)}
                  >
                    {currentPath === 'validar-apreciar-realizacao' ? (
                      <>Apreciar Realizações Lateralidade/Substituição</>
                    ) : (
                      <>Avaliar número de participantes Lateralidade/Substituição</>
                    )}
                  </Button>
                </div>
              )} */}
          </div>

          <div className="block mb-8 lg:mb-14">
            <h2 className="text-lg lg:text-[22px] font-light mb-4 lg:mb-6">Selecione a ação que deseja realizar</h2>

            <ul className="flex items-center space-y-4 lg:space-y-0 lg:space-x-4 flex-col lg:flex-row list-none">
              <li className="block">
                <Link
                  to="/minha-equipe"
                  className={`${
                    currentPath === 'minha-equipe'
                      ? 'bg-electric-blue ring-electric-blue text-prussian-blue-3 hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                      : 'hover:bg-electric-blue active:bg-electric-blue focus:bg-electric-blue hover:ring-electric-blue active:ring-electric-blue focus:ring-electric-blue ring-grey-light text-grey-light hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                  } inline-block text-sm font-normal ring-2 py-3 px-4 rounded-full no-underline hover:no-underline active:no-underline focus:no-underline uppercase`}
                >
                  VISUALIZAR LISTA DE FUNCIONÁRIOS
                </Link>
              </li>
              {!user?.extra.rede && (
                <li className="block">
                  <Link
                    to="/minha-equipe/validar-apreciar-realizacao"
                    className={`${
                      currentPath === 'validar-apreciar-realizacao'
                        ? 'bg-electric-blue ring-electric-blue text-prussian-blue-3 hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                        : 'hover:bg-electric-blue active:bg-electric-blue focus:bg-electric-blue hover:ring-electric-blue active:ring-electric-blue focus:ring-electric-blue ring-grey-light text-grey-light hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                    } inline-block text-sm font-normal ring-2 py-3 px-4 rounded-full no-underline hover:no-underline active:no-underline focus:no-underline uppercase`}
                  >
                    VALIDAR/APRECIAR REALIZAÇÃO
                  </Link>
                </li>
              )}
              {/* {!user?.extra.rede &&
                userInfo &&
                !!userInfo.is_manager && userInfo?.mad_dupla && (
                  <li className="block">
                    <Link
                      to="/minha-equipe/dupla-lideranca"
                      className={`${
                        currentPath === 'dupla-lideranca'
                          ? 'bg-electric-blue ring-electric-blue text-prussian-blue-3 hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                          : 'hover:bg-electric-blue active:bg-electric-blue focus:bg-electric-blue hover:ring-electric-blue active:ring-electric-blue focus:ring-electric-blue ring-grey-light text-grey-light hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                      } inline-block text-sm font-normal ring-2 py-3 px-4 rounded-full no-underline hover:no-underline active:no-underline focus:no-underline uppercase`}
                    >
                      LIDERANÇA COMPARTILHADA
                    </Link>
                  </li>
                )} */}
              {!!canViewTabEquipe && !user?.extra.rede && (
                <li className="block">
                  <Link
                    to="/minha-equipe/participantes-da-realizacao"
                    className={`${
                      currentPath === 'participantes-da-realizacao'
                        ? 'bg-electric-blue ring-electric-blue text-prussian-blue-3 hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                        : 'hover:bg-electric-blue active:bg-electric-blue focus:bg-electric-blue hover:ring-electric-blue active:ring-electric-blue focus:ring-electric-blue ring-grey-light text-grey-light hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                    } inline-flex items-center text-sm font-normal ring-2 py-3 px-4 rounded-full no-underline hover:no-underline active:no-underline focus:no-underline uppercase`}
                  >
                    AVALIAR NÚMERO DE PARTICIPANTES EM REALIZAÇÃO{' '}
                    {Array.isArray(tasksPendingApproval) && !!tasksPendingApproval.length ? (
                      <span className="bg-flame h-5 min-w-5 px-1 text-white ml-2 text-center rounded-full">
                        {tasksPendingApproval.length}
                      </span>
                    ) : null}
                  </Link>
                </li>
              )}
              {/* <li className="block">
                <Link
                  to="/minha-equipe/participacao-de-gerentes"
                  className={`${
                    currentPath === 'participacao-de-gerentes'
                      ? 'bg-electric-blue ring-electric-blue text-prussian-blue-3 hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                      : 'hover:bg-electric-blue active:bg-electric-blue focus:bg-electric-blue hover:ring-electric-blue active:ring-electric-blue focus:ring-electric-blue ring-grey-light text-grey-light hover:text-prussian-blue-3 active:text-prussian-blue-3 focus:text-prussian-blue-3'
                  } inline-block text-sm font-normal ring-2 py-3 px-4 rounded-full no-underline hover:no-underline active:no-underline focus:no-underline uppercase`}
                >
                  ANALISAR PARTICIPAÇÃO DE GERENTES
                </Link>
              </li> */}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className="mb-3 lg:mb-16 flex justify-between items-center">
            <div className="flex flex-ro items-center space-x-3">
              <button
                className="rounded-full bg-purple flex justify-center items-center p-1"
                onClick={() => onSubmitSearch(false)}
              >
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>

              <h1 className="text-lg lg:text-3xl py-1 rounded-full">{!!title ? title : 'Minha Equipe'}</h1>
            </div>
          </div>
        </>
      )}

      {showModalLateral && (
        <SearchGestor
          closeModal={() => setShowModalLateral(false)}
          onSubmit={id => {
            if (currentPath === 'validar-apreciar-realizacao' || currentPath === 'participantes-da-realizacao') {
              setStorageItem('manager_lateralidade', id._id);
              document.dispatchEvent(new CustomEvent('reload:lateralidade'));
            } else {
              onSubmitSearch(id);
            }

            setShowModalLateral(false);
          }}
        />
      )}

      {/* {Array.isArray(vacationManagers) &&
        !!vacationManagers.length &&
        (currentPath === 'validar-apreciar-realizacao' || currentPath === 'participacao-de-gerentes') && (
          <VacationManagerModal
            managers={vacationManagers}
            route={
              currentPath === 'validar-apreciar-realizacao'
                ? '/minha-equipe/validar-apreciar-realizacao'
                : '/minha-equipe/participacao-de-gerentes'
            }
            refresh
          />
        )} */}
    </>
  );
}
